import { getTagContent } from "../../../../../common-deprecated/utils";
import { useBnbSelector } from "../../redux/store";
import { isLexus } from "../../../../../common-deprecated/settings/utils/commonSettingUtils";
import { type BuildAndBuyLabelType, getBnbLabel, getBnbOptionalLabel, useBnbOptionalLabel } from "../../utils/labels";

export type ReserveStepsLabelType = {
    icon: string;
    text: string;
    // If the label includes an info tag, include a popover containing the rest in the info tag.
    // See OR-1813
    extraInfo?: string;
    extraText?: string;
};

type ReserveType = {
    labels: ReserveStepsLabelType[];
    enableTermsConditions: boolean;
    showReserveButton: boolean;
};
const useReserve = (): ReserveType => {
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const isLexusSetting = isLexus(commonSettings);
    const [
        termsAndConditonDescription,
        termsAndConditionScroll1,
        termsAndConditionScroll2,
        termsAndConditionExtra,
        termsAndConditionDescriptionMonthly,
        termsAndConditionScroll1Monthly,
        termsAndConditionScroll2Monthly,
        termsAndConditionExtraMonthly,
    ] = useBnbOptionalLabel([
        "reserveTermsConditionsDescription",
        "reserveTermsConditionsScroll1",
        "reserveTermsConditionsScroll2",
        "reserveTermsConditionsExtra",
        "reserveTermsConditionsDescriptionMonthly",
        "reserveTermsConditionsScroll1Monthly",
        "reserveTermsConditionsScroll2Monthly",
        "reserveTermsConditionsExtraMonthly",
    ]);

    const enableTermsConditions = !!(
        termsAndConditonDescription ||
        termsAndConditionScroll1 ||
        termsAndConditionScroll2 ||
        termsAndConditionExtra ||
        termsAndConditionDescriptionMonthly ||
        termsAndConditionScroll1Monthly ||
        termsAndConditionScroll2Monthly ||
        termsAndConditionExtraMonthly
    );

    const icons = isLexusSetting
        ? ["login", "lexus-build", "document", "login", "finance", "check"]
        : ["lock", "car", "file-alt", "user", "price-alt", "ok"];

    const labels = icons.reduce((acc: ReserveStepsLabelType[], icon, index) => {
        const label = `reserveStepTitle${index}${financeOption === "monthly" ? "Monthly" : ""}` as BuildAndBuyLabelType;

        if (getBnbOptionalLabel({ commonSettings, bnbSettings }, label)) {
            const item: ReserveStepsLabelType = {
                icon,
                text: getBnbLabel({ commonSettings, bnbSettings }, label),
            };
            if (item.text.includes("[INFO]")) {
                const leftLabelRegex = new RegExp("(.*)\\[INFO]", "i").exec(item.text) || [];
                const rightLabelRegex = new RegExp("\\[/INFO](.*)", "i").exec(item.text) || [];
                item.extraInfo = getTagContent("INFO", item.text);
                item.extraText = rightLabelRegex![1] || "";
                item.text = leftLabelRegex![1] || "";
            }
            if (item.text) acc.push(item);
        }

        return acc;
    }, []);

    // Only show the reserve button when at least one of the labels is defined.
    // Added on request of TGB so they are able to dynamically show and hide the reserve button.
    const [reserveNowLabel, reserveNowMonthlyLabel] = useBnbOptionalLabel([
        "reserveReserveNow",
        "reserveReserveNowMonthly",
    ]);

    const showReserveButton = !!(reserveNowLabel || reserveNowMonthlyLabel);

    return {
        labels,
        enableTermsConditions,
        showReserveButton,
    };
};

export default useReserve;
